import React, { useState, useEffect } from "react";

import { isMobileOnly } from 'react-device-detect';

import DateUtil from "../../common/dateUtil";

import ErrorComp from "../common/ErrorComp";
import LoadingComp from "../common/LoadingComp";

import GiftSearchCriteriaComp from "./GiftSearchCriteriaComp";
import GiftGridComp from "./GiftGridComp";
import GiftListComp from "./GiftListComp";

import GiftDetailComp from "./GiftDetailComp";

import { fetchCall } from "../../common/FetchHelpers";

const GiftSearchComp = (props)=>{
  
  const searchUrl = "api/gift/search";
  const detailUrl = "api/gift/details/";
  
    let initFromDate = new Date(new Date());
    initFromDate.setDate(initFromDate.getDate() - 90);
    
    const fromDateStr = DateUtil.toIsoStrDate(initFromDate);
    
    const initFormData = {
      contribType: "",
      campaign: "",
      politicalParty: "",
      fromDate: fromDateStr,
      toDate: DateUtil.toIsoStrDate(new Date()),
      reqStatus: "APPROVED,PENDING,REJECTED",
      giftTypes:"Gift,Meal,Accomodation,Event"
    };
    
    const [reloadResult, setReloadResult] = useState(false);
    const [searchCriteria, setSearchCriteria] = useState(initFormData);
    
    const [showError, setShowError] = useState(false);
    const [loading, setLoading] = useState(false);
    const [showResult, setShowResult] = useState(false);
    const [showDetail, setShowDetail] = useState(false);
    
    const [items, setItems] = useState([]);
    const [currentItem, setCurrentItem] = useState({});
    
    const [dataFrame, setDataFrame] = useState({ startIndex: 0, limit: 10 });
    
    const searchItems = (jsonData) => {
        setLoading(true);
        setSearchCriteria(jsonData);

        const fetchConfig ={
          method: "POST",
          cache: "no-cache",
          redirect: "follow",
          referrerPolicy: "no-referrer",
          headers:{
            "Content-Type": "application/json"
          },
          body: JSON.stringify(jsonData),
        }

        fetchCall(searchUrl, fetchConfig)
          .then((result)=>{
            setDataFrame({ startIndex: 0, limit: 10 });
            setItems(result);
            setLoading(false);
            setShowResult(true);
            setReloadResult(false);
          },
          (err)=>{
            setLoading(false);
            setShowError(true);
          }
        );
      };

    const onSearch = (criteria) => {
        setShowResult(false);
    
        searchItems(criteria);
      };
    
      const detailClickHandler = (id) => {
        setShowResult(false);
        setLoading(true);
        const url = detailUrl + id;

        fetchCall(url)
          .then((result)=>{
            setLoading(false);
            setCurrentItem(result);
            setShowDetail(true);

          },
          (err)=>{
            setLoading(false);
            setShowError(true);
          }
        );
      };

  const handleReloadItem =(id)=>{
    console.log("Reloading {id}",id);
    const url = detailUrl + id;

    fetchCall(url)
      .then((result)=>{
        console.log(result);
        setCurrentItem(result);
        setReloadResult(true);
      },
      (err)=>{
        console.log(err);
      }
    );
  };

      const handleCloseDetail = () => {
        setShowDetail(false);
        if(reloadResult){
          onSearch(searchCriteria);
        } else{
          setShowResult(true);
        }
      };

      useEffect(() => {
        searchItems(initFormData);
        if(props.giftId){
          detailClickHandler(props.giftId);
        }
      }, []);

      useEffect(() => {
        if(props.giftId){
          detailClickHandler(props.giftId);
          //setShowResult(false);
        }
      }, [props.t]);
    

    return (
        <div>
            {!showDetail && <GiftSearchCriteriaComp onSearch={onSearch}/>}
            
            {showResult && !showDetail && (
                <div>
                {isMobileOnly && <GiftListComp items={items} dataFrame={dataFrame} setDataFrame={setDataFrame} onDetail={detailClickHandler} />}
                {!isMobileOnly && <GiftGridComp items={items} dataFrame={dataFrame} setDataFrame={setDataFrame} onDetail={detailClickHandler} />}
                </div>
            )}

            {showDetail && (
                    <GiftDetailComp
                    data={currentItem}
                    title="Details"
                    reloadItem={handleReloadItem}
                    handleUpdate={p=>props.handleUpdate(currentItem)}
                    handleClose={handleCloseDetail}
                    />
                )}

            {showError && <ErrorComp />}
            {loading && <LoadingComp />}

        </div>
    );
}


export default GiftSearchComp;
